import { useState, useEffect } from "react";

const API = "https://pax-ordinis-app-db9z.vercel.app/api";

const Evening = () => {

const [rule,setRule]=useState(null);
const [commitments,setCommitments]=useState({});
const [saveStatus,setSaveStatus]=useState("");
const [loaded,setLoaded]=useState(false);


const items=[

{ id:"remembered_christ",text:"I remembered Christ during the day" },

{ id:"returned_after_failure",text:"I returned after distraction or failure" },

{ id:"duties_kept",text:"I kept my duties faithfully" },

{ id:"charity_practiced",text:"I practiced charity toward others" },

{ id:"interior_peace_guarded",text:"I guarded my interior peace" }

];



function formatSavedTime(){

const now=new Date();

return(
"Saved "+
now.toLocaleDateString("en-US",{month:"short",day:"numeric"})+
", "+
now.toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit"})
);

}



/* LOAD */

useEffect(()=>{

const token=localStorage.getItem("token");
if(!token) return;

fetch(API+"/daily-rule",{

headers:{
Authorization:"Bearer "+token

}

})
.then(res=>res.json())
.then(data=>{

setRule(data);

setCommitments(data.examen_checkboxes || {});

setLoaded(true);

});

},[]);



/* SAVE */

function saveEvening(newState){

if(!loaded) return;

const token=localStorage.getItem("token");
if(!token) return;

setSaveStatus("Saving...");


const updatedRule={

...rule,

examen_checkboxes:newState

};


fetch(API+"/daily-rule",{

method:"POST",

headers:{
"Content-Type":"application/json",
Authorization:"Bearer "+token

},

body:JSON.stringify(updatedRule)

})

.then(()=>{

setRule(updatedRule);

setSaveStatus(formatSavedTime());

})
.catch(()=>{

setSaveStatus("Offline");

});

}



function handleClick(id){

const updated={

...commitments,
[id]:!commitments[id]

};

setCommitments(updated);

saveEvening(updated);

}



return(

<div className="evening-space">

<h1 className="evening-title">

Evening

</h1>


<p className="evening-subtitle">

Gather and release

</p>



<div className="evening-scorecard">

{items.map(item=>(

<div

key={item.id}

className={`evening-item ${commitments[item.id]?"evening-checked":""}`}

onClick={()=>handleClick(item.id)}

>

{commitments[item.id]?"●":"○"} {item.text}

</div>

))}

</div>



<div style={{

marginTop:"10px",
fontSize:"12px",
opacity:0.6

}}>

{saveStatus}

</div>


</div>

);

};

export default Evening;
